import { Routes, Route } from 'react-router-dom';
import PolicyList from './PolicyList';
import PolicyCreate from './PolicyCreate';
import PolicyDetail from './PolicyDetail';

/**
 * 权限策略子模块路由。列表 / 新建 / 编辑 / 详情均为模块内部路由，
 * 对外只暴露挂载点 `/iam/policies/*`，与 users / groups 子模块保持一致的结构。
 */
export default function IamPoliciesRoutes() {
  return (
    <Routes>
      <Route index element={<PolicyList />} />
      <Route path="create" element={<PolicyCreate />} />
      <Route path=":id" element={<PolicyDetail />} />
      <Route path=":id/edit" element={<PolicyCreate />} />
    </Routes>
  );
}
